import {createSelector} from 'reselect';
import {getPickTimestamp} from 'components/Cards/Pick/helpers';

const favoritePicksState = state => state.favoritePicks;

export const getFavoritePicks = createSelector(favoritePicksState, favoritePicks => favoritePicks);

export const getFavoritePicksCount = createSelector(getFavoritePicks, ({length}) => length);

export const checkPickIsFavorite = ({selection, eventId}) =>
  createSelector(getFavoritePicks, favoritePicks => {
    const favoritePick = favoritePicks.find(pick => {
      return pick.pick === selection && pick.event.id === eventId;
    });
    return Boolean(favoritePick);
  });

export const getSortedFavoritePicks = createSelector(getFavoritePicks, favoritePicks =>
  favoritePicks.sort((a, b) => getPickTimestamp(a.event) - getPickTimestamp(b.event)),
);
